import { render, staticRenderFns } from "./DeliveryFormModal.vue?vue&type=template&id=a2aa304e&lang=pug"
import script from "./DeliveryFormModal.vue?vue&type=script&lang=js"
export * from "./DeliveryFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports